import { createBrowserRouter } from 'react-router-dom';
import routeConfig from './routeConfig';

const appRouter = createBrowserRouter(routeConfig);

export default appRouter;
